<h1>Post Lab Data <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-8 border-right">
        <form [formGroup]="labLeadModalForm" (submit)="submitLabLead()">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <label class="form-label">Lead Name *</label>
                        <input type="text" formControlName="name" class="form-control" readonly/>
                        <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                            <div *ngIf="f.name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Lead Mobile *</label>
                        <input type="text" formControlName="mobile" class="form-control"  readonly/>
                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                            <div *ngIf="f.mobile.errors.required">Mobile is required</div>
                            <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid Mobile number format
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mt-5">
                        <label class="form-label">Lab Test Category *</label>
                        <mat-select placeholder="Select Test Category" formControlName="lab_test_category"
                            (selectionChange)="getLabTestCategorySubcategory($event.value)"
                            (click)="setSearchValue('labtest')">
                            <input class="mySearchInput" #testSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'labtest')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="testSearch">
                            <mat-option>Select Test</mat-option>
                            <mat-option [value]="test.id" *ngFor="let test of labTest">{{test.name}}
                            </mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.lab_test_category.errors" class="invalid-feedback">
                            <div *ngIf="f.lab_test_category.errors.required">Lab test catergory is required</div>
                        </div>
                    </div>
                    <div class="col-md-6 mt-5">
                        <label class="form-label">Lab Test Subcategory *</label>
                        <mat-select placeholder="Select Test Subcategory" formControlName="lab_test_subcategory"
                            [disabled]="test_subcategory" (click)="setSearchValue('labtestsub')">
                            <input class="mySearchInput" #categorySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'labtestsub')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="categorySearch">
                            <mat-option>Select Test</mat-option>
                            <mat-option [value]="sub.id" *ngFor="let sub of labTestSubcategory">{{sub.name}}
                            </mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.lab_test_subcategory.errors" class="invalid-feedback">
                            <div *ngIf="f.lab_test_subcategory.errors.required">Subcategory is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-5" *ngIf="labLeadModalForm.controls['lab_test_category'].value==765">
                        <label class="form-label">Description: (<i>Paste the category and subcategory with your query name here if not exist in dropdown. Anaesthetist team will add.</i>)</label>
                        <textarea rows="3" formControlName="bd_description" class="form-control"></textarea>
                    </div>

                    <div class="col-md-6 mt-5">
                        <label class="form-label">Address:</label>
                        <textarea rows="3" formControlName="patient_address" class="form-control"></textarea>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Upload Aadhar Card</label>
                        <input type="file" (change)="selectAadhar($event)" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>
</div>
    
